import { useMemo } from 'react'
import type { ReactNode } from 'react'
import { useAuth } from '../../hooks/auth/useAuth'
import { AuthContext, type AuthContextType } from './AuthContextDef'

export function AuthProvider({ children }: { children: ReactNode }) {
  const { user, loading, getToken } = useAuth()

  const value = useMemo<AuthContextType>(
    () => ({ user, loading, getToken }),
    [user, loading, getToken]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
